import { isValidYyyyMmDd } from "./calendarYmd";
import { buildEventsManagementPath, EVENT_MGMT_TAB_EVENTS } from "./eventManagementTabs";
import { buildFyWindowYmdForYear, sopFyUsesYtdAsOf } from "./fyDateWindow";

export const AOP_ACTUAL_EVENTS_DRILL_SOURCE = "ops_plan_dashboard";
export const AOP_ACTUAL_EVENTS_DRILL_SOURCE_SOP = "ops_plan_sop";

export const AOP_BREAKDOWN_SUMMARY = "summary";
export const AOP_BREAKDOWN_WEEKLY = "weekly";
export const AOP_BREAKDOWN_MONTHLY = "monthly";

/** Map AOP row program label to Events `program` query param (_id or __none__). */
export function resolveProgramIdForAopDrill(programName, programs) {
  const name = (programName || "").trim();
  if (!name || name === "—") return "__none__";
  const match = (programs || []).find((p) => (p.name || "").trim() === name);
  return match?._id ?? null;
}

export function buildAopActualEventsDrillPath({
  programId,
  breakdown,
  fyStartDate,
  asOfDate,
  period,
}) {
  const params = {
    tab: EVENT_MGMT_TAB_EVENTS,
    status: "closed",
    drillSource: AOP_ACTUAL_EVENTS_DRILL_SOURCE,
    navView: "all",
  };

  if (programId) params.program = programId;

  if (breakdown === AOP_BREAKDOWN_SUMMARY) {
    if (isValidYyyyMmDd(fyStartDate)) params.startDate = fyStartDate;
    if (isValidYyyyMmDd(asOfDate)) params.endDate = asOfDate;
  } else if (period?.startYmd && period?.endYmd) {
    if (isValidYyyyMmDd(period.startYmd)) params.startDate = period.startYmd;
    if (isValidYyyyMmDd(period.endYmd)) params.endDate = period.endYmd;
  }

  return buildEventsManagementPath(params);
}

export function buildAopActualDrillPathForCell({
  programName,
  breakdown,
  fyStartDate,
  asOfDate,
  period,
  programs,
  isTotalRow = false,
}) {
  let programId = null;
  if (!isTotalRow) {
    programId = resolveProgramIdForAopDrill(programName, programs);
    if (programId === null) return null;
  }
  return buildAopActualEventsDrillPath({
    programId: isTotalRow ? null : programId,
    breakdown,
    fyStartDate,
    asOfDate,
    period,
  });
}

export function buildSopEventActualDrillPath({
  fiscalYear,
  programName,
  programs,
  currentFy,
  currentFyStartDate,
  asOfDate,
}) {
  const programId = resolveProgramIdForAopDrill(programName, programs);
  if (programId === null) return null;

  const window = buildFyWindowYmdForYear(fiscalYear, currentFy, currentFyStartDate, {
    asOfYmd: sopFyUsesYtdAsOf(fiscalYear, currentFy) ? asOfDate : null,
  });
  if (!window || !isValidYyyyMmDd(window.fyStartYmd) || !isValidYyyyMmDd(window.fyEndYmd)) {
    return null;
  }

  return buildEventsManagementPath({
    tab: EVENT_MGMT_TAB_EVENTS,
    status: "closed",
    drillSource: AOP_ACTUAL_EVENTS_DRILL_SOURCE_SOP,
    navView: "all",
    program: programId,
    startDate: window.fyStartYmd,
    endDate: window.fyEndYmd,
  });
}

export function getAopEventsDrillSourceLabel(drillSource) {
  if (drillSource === AOP_ACTUAL_EVENTS_DRILL_SOURCE) return "Ops Plan Dashboard";
  if (drillSource === AOP_ACTUAL_EVENTS_DRILL_SOURCE_SOP) return "Strategic Operating Plan";
  if (drillSource === "closed_events_metrics") return "Closed Events Metrics";
  return "Registration Metrics";
}
